import React, { Component } from 'react';
import FilteredListRosters from './filteredListRosters';
import { end_point } from './helper.js';
//import ProgramForm from './programForm';

class programRosters extends Component {

    constructor(props) {
        super(props);
        this.state = {
          labelFields: [
            {"name":"season", "size": "10%"},
            {"name":"ages", "size": "10%"},
            {"name":"division", "size": "10%"},
            {"name":"group_name", "size": "26%"},
            {"name":"type", "size": "10%"},
            {"name":"status", "size": "10%"},
            {"name":"head_coach", "size": "10%"},
            {"name":"start_date","size": "10%"},
            {"name":"program_info","size": "4%"}
          ],
          filterableFields: ["season",  "ages",  "division", "group_name", "type",  "status", "head_coach", "start_date"],
          endpoint: `${end_point('programs')}/programs`
        }
    }

    render() {
        return(
        <FilteredListRosters filterableFields={this.state.filterableFields} labelFields={this.state.labelFields} endpoint={this.state.endpoint} heading="Rosters"/>
      );
    }
}

export default programRosters;
